export default __webpack_public_path__ + "static/media/Doctor.1beda341.png";